import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function GetInventoryLogsService(token, data = {}) {
    return axios.post(`${CURRENT_API_URL}/sellerPartner/getInventoryLogs`, data || {}, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Inventory data fetched successfully");
        return res.data;
    }).catch(error => {
        console.log("Error in GetInventoryLogsService:", error);
        notify.NotifyError("An error occurred while fetching inventory logs. Please try again later.");
        return false;
    });
}

export default GetInventoryLogsService;